<template>
  <BusiformMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
